import { ReactNode } from 'react';

import { DeleteTemplatePopup } from '../components/popups/delete-template-popup';
import { UpdateTemplatePopup } from '../components/popups/update-template-popup';
import { PopupType } from '../enums/popup-type.const';

export type PopupTypeComponentMap = Record<PopupType, ReactNode>;

export const popupTypeComponentMap: PopupTypeComponentMap = {
  [PopupType.DELETE_TEMPLATE]: <DeleteTemplatePopup />,
  [PopupType.UPDATE_TEMPLATE]: <UpdateTemplatePopup />,
  [PopupType.MAP_FIELDS]: null,
};
